import React from 'react'
import PropTypes from 'prop-types'
import Location from './Location'
import {
  setIsSearching,
  setLocationEnabledWarning,
  setMarkerAddress,
  clearMarkersDone,
  initialiseMapWithLocationAction
} from './LocationContainerActions'
import { setUserAddress } from '../searchCriteriaActions'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

class LocationContainer extends React.Component {
  static propTypes = {
    locationContainer: PropTypes.object.isRequired,
    setUserAddress: PropTypes.func.isRequired,
    setIsSearching: PropTypes.func.isRequired,
    setLocationEnabledWarning: PropTypes.func.isRequired,
    setMarkerAddress: PropTypes.func.isRequired,
    isSearching: PropTypes.bool.isRequired,
    showLocationWarning: PropTypes.bool.isRequired,
    markerAddress: PropTypes.string.isRequired,
    showValidationErrors: PropTypes.bool.isRequired,
    shouldClear: PropTypes.bool.isRequired,
    clearMarkersDone: PropTypes.func.isRequired,
    validation: PropTypes.object.isRequired,
    initialiseMap: PropTypes.bool.isRequired,
    initialLocation: PropTypes.object.isRequired,
    initialiseMapWithLocationProp: PropTypes.func.isRequired
  }

  constructor (props) {
    super(props)

    this.state = {
      markerAddress: '',
      // _map is too big to clone with lodash everytime we clone the store, it breaks the application.
      _map: null,
      markers: []
    }

    this.placesChanged = this.placesChanged.bind(this)
    this.onGoogleApiLoaded = this.onGoogleApiLoaded.bind(this)
    this.getLocation = this.getLocation.bind(this)
    this.createMarkerAndMoveMapCentre = this.createMarkerAndMoveMapCentre.bind(this)
    this.setIsSearching = this.setIsSearching.bind(this)
    this.setLocationEnabledWarning = this.setLocationEnabledWarning.bind(this)
    this.addMarker = this.addMarker.bind(this)
    this.deleteAndClearMarkers = this.deleteAndClearMarkers.bind(this)
    this.tilesLoaded = this.tilesLoaded.bind(this)
    this.initialiseMapWithLocation = this.initialiseMapWithLocation.bind(this)
  }

  shouldComponentUpdate (nextProps, nextState) {
    return nextProps.isSearching !== this.props.isSearching ||
      nextProps.showLocationWarning !== this.props.showLocationWarning ||
      nextProps.markerAddress !== this.props.markerAddress ||
      nextProps.showValidationErrors !== this.props.showValidationErrors ||
      nextProps.validation.help !== this.props.validation.help ||
      nextProps.initialiseMap !== this.initialiseMap
  }

  componentDidUpdate(prevProps) {
    // Compare current props to previous props
    if (this.props.searchCriteriaChanged &&
      this.props.searchCriteria !== prevProps.searchCriteria) {
      this.props.fetchTotalMatchingProfiles(this.props.searchCriteria);
    }
  }

  componentWillUnmount () {
    if (this.state._map && this.state._map.map) {
      this.state._map.map.unbind('tilesloaded', this.tilesLoaded)
      this.state._map.map.unbind('idle', this.tilesLoaded)
    }
  }

  addMarker (marker) {
    var markers = [...this.state.markers]
    markers.push(marker)
    this.setState({
      markers: markers
    })
  }

  deleteAndClearMarkers () {
    if (this.state.markers) {
      this.state.markers.forEach((marker) => marker.setMap(null))
    }
    this.state.markers = []

    this.props.clearMarkersDone()
  }

  tilesLoaded () {
    this.setIsSearching(false)
  }

  geoCodeLatLang (latlng, map, title, addMarker, setMarkerAddress) {
    const geocoder = new google.maps.Geocoder()
    geocoder.geocode({'location': latlng}, function (results, status) {
      if (status === 'OK') {
        if (results[1]) {
          map.setCenter(latlng)
          map.setZoom(17)
          var marker = new google.maps.Marker({
            position: latlng,
            map: map,
            title: title
          })
          var infowindow = new google.maps.InfoWindow()
          addMarker(marker)
          infowindow.close()
          infowindow.setContent(results[0].formatted_address)
          setMarkerAddress(results[0].formatted_address)
          infowindow.open(map, marker)
        }
      }
    })
  }

  createMarkerAndMoveMapCentre (latitude, longitude, title, map) {

    var latlng = {lat: parseFloat(latitude), lng: parseFloat(longitude)}

    var addMarker = this.addMarker
    var setMarkerAddress = this.props.setMarkerAddress
    map.addListener('tilesLoaded', this.tilesLoaded)
    map.addListener('center_changed', this.tilesLoaded)

    this.geoCodeLatLang(latlng, map, title, addMarker, setMarkerAddress)
  }

  placesChanged (places) {
    this.setIsSearching(true)
    this.deleteAndClearMarkers()

    let place = places[0]
    let lat = place.geometry.location.lat()
    let lng = place.geometry.location.lng()
    let selectedAddress = place['formatted_address']

    if (this.mapIsNotInitialised()) {
      let latlng = {lat: lat, lng: lng}
      this.props.setUserAddress(`${lat} ${lng}`)
      this.initialiseMapWithLocation(latlng)
    } else if (this.reloadMap() && places.length > 0) {
      let map = this.state._map.map
      this.createMarkerAndMoveMapCentre(lat, lng, selectedAddress, map)
      this.props.setUserAddress(`${lat} ${lng}`)
      // Keep the stored location current so returning to the page reopens the map where the user last searched
      this.initialiseMapWithLocation({lat: lat, lng: lng})
    }
  }

  mapIsNotInitialised () {
    return !this.props.initialiseMap
  }

  reloadMap () {
    return this.state._map && this.state._map.map
  }

  getLocation () {
    this.setIsSearching(true)
    this.deleteAndClearMarkers()

    var handleGetCurrentPositionSuccess = function (position) {
      let longitude = position.coords.longitude
      let latitude = position.coords.latitude

      if (this.mapIsNotInitialised()) {
        let latlng = {lat: latitude, lng: longitude}
        this.initialiseMapWithLocation(latlng)
        this.props.setUserAddress(`${latitude} ${longitude}`)
      } else if (this.reloadMap()) {
        var map = this.state._map.map
        this.createMarkerAndMoveMapCentre(latitude, longitude, 'Your location', map)
        this.props.setUserAddress(`${latitude} ${longitude}`)
        this.initialiseMapWithLocation({lat: latitude, lng: longitude})
        this.setLocationEnabledWarning(false)
      }
    }

    handleGetCurrentPositionSuccess = handleGetCurrentPositionSuccess.bind(this)
    var getPositionError = function (geoError) {
      this.setLocationEnabledWarning(true)
      this.setIsSearching(false)
    }
    getPositionError = getPositionError.bind(this)

    navigator.geolocation.getCurrentPosition(handleGetCurrentPositionSuccess, getPositionError)
  }

  onGoogleApiLoaded (map) {
    const latlngObject = map.map.getCenter()
    var latlng = {lat: latlngObject.lat(), lng: latlngObject.lng()}
    this.setState({ _map: map })
    this.setIsSearching(false)
    let addMarker = this.addMarker
    var setMarkerAddress = this.props.setMarkerAddress
    this.geoCodeLatLang(latlng, map.map, 'selectedAddress', addMarker, setMarkerAddress)
  }

  setIsSearching (value) {
    this.props.setIsSearching(value)
  }

  setLocationEnabledWarning (value) {
    this.props.setLocationEnabledWarning(value)
  }

  initialiseMapWithLocation (location) {
    this.props.initialiseMapWithLocationProp(location)
  }

  render () {
    return (
      <Location
        showValidationErrors={this.props.showValidationErrors}
        validation={this.props.validation}
        placesChanged={this.placesChanged}
        onGoogleApiLoaded={this.onGoogleApiLoaded}
        getLocation={this.getLocation}
        createMarkerAndMoveMapCentre={this.createMarkerAndMoaveMapCentre}
        isSearching={this.props.isSearching}
        showLocationWarning={this.props.showLocationWarning}
        setMarkerAddress={this.props.setMarkerAddress}
        markerAddress={this.props.locationContainer.markerAddress}
        initialLocation={this.props.initialLocation}
        initialiseMap={this.props.initialiseMap}
      />
    )
  }
}

const mapStateToProps = ({ locationContainer }) => {
  return {
    locationContainer: locationContainer,
    isSearching: locationContainer.isSearching,
    showLocationWarning: locationContainer.showLocationWarning,
    markerAddress: locationContainer.markerAddress,
    shouldClear: locationContainer.shouldClear,
    initialiseMap: locationContainer.initialiseMap,
    initialLocation: locationContainer.initialLocation
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    setIsSearching: setIsSearching,
    setLocationEnabledWarning: setLocationEnabledWarning,
    setUserAddress: setUserAddress,
    setMarkerAddress: setMarkerAddress,
    clearMarkersDone: clearMarkersDone,
    initialiseMapWithLocationProp: initialiseMapWithLocationAction
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(LocationContainer)

